/* Velaura — JS del tema */
(function () {
  'use strict';

  /* ---------- Menu mobile ---------- */
  var menuToggle = document.querySelector('[data-menu-toggle]');
  if (menuToggle) {
    var mobileMenu = document.getElementById('MobileMenu');
    var iconMenu = menuToggle.querySelector('[data-icon-menu]');
    var iconClose = menuToggle.querySelector('[data-icon-close]');
    menuToggle.addEventListener('click', function () {
      var open = mobileMenu.hidden;
      mobileMenu.hidden = !open;
      menuToggle.setAttribute('aria-expanded', String(open));
      iconMenu.hidden = open;
      iconClose.hidden = !open;
    });
  }

  /* ---------- Stepper quantità (prodotto + carrello) ---------- */
  document.querySelectorAll('.quantity-stepper').forEach(function (stepper) {
    var input = stepper.querySelector('input');
    var minus = stepper.querySelector('[data-qty-minus]');
    var plus = stepper.querySelector('[data-qty-plus]');
    if (!input) return;
    var min = parseInt(input.min || '1', 10);

    function setValue(v) {
      input.value = Math.max(min, v);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (minus) minus.addEventListener('click', function () { setValue(parseInt(input.value || '1', 10) - 1); });
    if (plus) plus.addEventListener('click', function () { setValue(parseInt(input.value || '1', 10) + 1); });
  });

  /* ---------- Carrello: aggiorna al cambio quantità ---------- */
  var cartForm = document.querySelector('[data-cart-form]');
  if (cartForm) {
    var submitTimer;
    cartForm.querySelectorAll('[data-cart-qty]').forEach(function (input) {
      input.addEventListener('change', function () {
        clearTimeout(submitTimer);
        submitTimer = setTimeout(function () { cartForm.submit(); }, 350);
      });
    });
  }

  /* ---------- Pagina prodotto ---------- */
  var productSection = document.querySelector('[data-product-section]');
  if (!productSection) return;

  var variantDataEl = productSection.querySelector('[data-variant-data]');
  var stringsEl = productSection.querySelector('[data-strings]');
  var variants = variantDataEl ? JSON.parse(variantDataEl.textContent) : [];
  var strings = stringsEl ? JSON.parse(stringsEl.textContent) : {};

  var form = productSection.querySelector('[data-product-form]') || productSection.querySelector('form[action*="/cart/add"]');
  var variantIdInput = productSection.querySelector('[data-variant-id]');
  var atcButton = productSection.querySelector('[data-atc-button]');
  var atcText = productSection.querySelector('[data-atc-text]');
  var priceWrap = document.getElementById('ProductPrice');
  var mainImage = document.getElementById('ProductMainImage');
  var stickyBar = productSection.querySelector('[data-sticky-atc]');
  var stickyPrice = productSection.querySelector('[data-sticky-price]');
  var stickyButton = productSection.querySelector('[data-sticky-button]');

  /* ---------- Galleria prodotto: miniature, frecce, swipe, tastiera ---------- */
  var galleryApi = null;
  var gallery = productSection.querySelector('[data-gallery]');
  if (gallery && mainImage) {
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('[data-thumb]'));
    var slides = thumbs.length
      ? thumbs.map(function (t) { return t.getAttribute('data-image-url'); })
      : [mainImage.getAttribute('src')];
    var current = 0;
    var currentUrl = mainImage.getAttribute('src');

    thumbs.forEach(function (t, i) { if (t.classList.contains('is-active')) current = i; });

    function showImage(index) {
      if (!slides.length) return;
      current = (index + slides.length) % slides.length; // navigazione circolare
      var url = slides[current];
      if (url && url !== currentUrl) {
        currentUrl = url;
        mainImage.classList.add('is-loading');
        mainImage.setAttribute('src', url);
        // Senza rimuovere srcset il browser continua a mostrare l'immagine del srcset, ignorando il nuovo src.
        mainImage.removeAttribute('srcset');
      }
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === current); });
    }

    function showImageByUrl(url) {
      if (!url) return;
      var idx = slides.indexOf(url);
      if (idx === -1) { slides.push(url); idx = slides.length - 1; }
      showImage(idx);
    }

    mainImage.addEventListener('load', function () { mainImage.classList.remove('is-loading'); });

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { showImage(i); });
    });

    var prevBtn = gallery.querySelector('[data-gallery-prev]');
    var nextBtn = gallery.querySelector('[data-gallery-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { showImage(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { showImage(current + 1); });

    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); showImage(current - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); showImage(current + 1); }
    });

    var touchStartX = null;
    var viewport = gallery.querySelector('[data-gallery-viewport]') || mainImage;
    viewport.addEventListener('touchstart', function (e) { touchStartX = e.changedTouches[0].clientX; }, { passive: true });
    viewport.addEventListener('touchend', function (e) {
      if (touchStartX === null) return;
      var dx = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(dx) > 40) showImage(dx < 0 ? current + 1 : current - 1); // swipe
      touchStartX = null;
    }, { passive: true });

    galleryApi = { show: showImage, showByUrl: showImageByUrl };
  }

  /* Selezione variante */
  function selectedOptions() {
    var opts = [];
    productSection.querySelectorAll('.product__option').forEach(function (fieldset) {
      var checked = fieldset.querySelector('input:checked');
      opts.push(checked ? checked.value : null);
    });
    return opts;
  }

  function findVariant(opts) {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === opts[i]; });
    });
  }

  function renderPrice(variant) {
    if (!priceWrap) return;
    var html = '<div class="price' + (variant.compare_formatted ? ' price--sale' : '') + '">';
    html += '<span class="price__current">' + variant.price_formatted + '</span>';
    if (variant.compare_formatted) {
      html += '<s class="price__compare">' + variant.compare_formatted + '</s>';
      if (variant.save_percent && strings.save_percent) {
        html += '<span class="price__save">' + strings.save_percent.replace('[P]', variant.save_percent) + '</span>';
      }
    }
    html += '</div>';
    priceWrap.innerHTML = html;
    if (stickyPrice) stickyPrice.textContent = variant.price_formatted;
  }

  function updateVariant() {
    if (!variants.length) return;
    var variant = findVariant(selectedOptions());
    var available = !!(variant && variant.available);

    if (variantIdInput && variant) variantIdInput.value = variant.id;

    if (atcButton) {
      atcButton.disabled = !available;
      if (atcText) {
        atcText.textContent = !variant ? (strings.unavailable || '') : (available ? strings.add_to_cart : strings.sold_out);
      }
    }
    if (stickyButton) stickyButton.disabled = !available;
    if (variant) {
      renderPrice(variant);
      if (variant.image) {
        if (galleryApi) galleryApi.showByUrl(variant.image);
        else if (mainImage) { mainImage.setAttribute('src', variant.image); mainImage.removeAttribute('srcset'); }
      }
    }
  }

  productSection.querySelectorAll('.product__option-input').forEach(function (input) {
    input.addEventListener('change', updateVariant);
  });

  /* Barra sticky su mobile: appare quando il pulsante principale esce dallo schermo */
  if (stickyBar && atcButton && 'IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      stickyBar.hidden = entries[0].isIntersecting;
    }, { rootMargin: '-60px 0px 0px 0px' });
    observer.observe(atcButton);
  }
})();
